import { render } from "./eat_cook_categories.vue?vue&type=template&id=4e4c8b2a&ts=true"
import script from "./eat_cook_categories.vue?vue&type=script&lang=ts"
export * from "./eat_cook_categories.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__